import type { DocumentType } from '@/features/documents/constants';
import { api } from '@/api';
import type {
  ChatContinuation,
  ChatEmailNotification,
  OperationRun,
  ChatHydrateMessage,
  StaleAnalysisNotice,
} from '@/features/chat/types';

export const getChatHydrate = (threadId: string, evalId: string, evalType: DocumentType) =>
  api.get<{
    messages: ChatHydrateMessage[];
    continuations?: ChatContinuation[];
    operations?: OperationRun[];
    staleAnalyses?: StaleAnalysisNotice[] | null;
    emailNotification?: ChatEmailNotification | null;
  }>('v1/chat/hydrate', { params: { chatSessionId: threadId, evalId, evalType } });
